// AUTO-GENERATED by tools/fetch_gift_products.py on 2026-09-08
// Source: live primestyle.com collection JSON + Daily Renders manifest.
// RANKING: real units sold, 365-day orders window. bestSeller:true marks the piece each category card names.
// PRICING: every figure is a live store price. retail/ps = the default
// variant's compare_at/price; psMin/retailMin = the cheapest purchasable
// variant's price/compare_at (the as-low-as floor, D39). No campaign
// discount is applied anywhere. Do not hand-edit.
window.PS_GIFT = {
 "generatedAt": "2026-09-08",
 "salesSignal": "units",
 "ordersWindowDays": 365,
 "categories": [
  {
   "key": "best",
   "label": "Best Sellers",
   "handle": null,
   "products": [
    {
     "core": "71106",
     "sku": "71106-2",
     "rank": 0,
     "handle": "1-00-5-00-ct-round-cut-diamonds-tennis-bracelet-71106",
     "title": "1.00-5.00 CT Round Natural Diamond Tennis Bracelet",
     "fullTitle": "1.00-5.00 CT Round Cut Natural Diamonds - Tennis Bracelet",
     "url": "https://primestyle.com/products/1-00-5-00-ct-round-cut-diamonds-tennis-bracelet-71106",
     "origin": "Natural",
     "retail": 6480.0,
     "ps": 2089.99,
     "psMin": 2089.99,
     "retailMin": 6480.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.00CT Total",
      "2.00CT Total",
      "4.00CT Total",
      "5.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71106-a-73c9b592.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71106-b-a10f6a11.jpg"),
     "imgSource": "render",
     "units": 17,
     "bestSeller": true
    },
    {
     "core": "71731",
     "sku": "71731-2",
     "rank": 1,
     "handle": "2-50-6-00-ct-round-cut-diamonds-eternity-ring-71731",
     "title": "2.50-6.00 CT Round Natural Diamond Eternity Ring",
     "fullTitle": "2.50-6.00 CT Round Cut Natural Diamonds - Eternity Rings",
     "url": "https://primestyle.com/products/2-50-6-00-ct-round-cut-diamonds-eternity-ring-71731",
     "origin": "Natural",
     "retail": 7990.0,
     "ps": 2512.99,
     "psMin": 2512.99,
     "retailMin": 7990.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "2.50CT Total",
      "4.00CT Total",
      "6.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71731-a-0c4d19ec.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71731-b-32ca08c5.jpg"),
     "imgSource": "render",
     "units": 12,
     "bestSeller": true
    },
    {
     "core": "102676",
     "sku": "102676-2",
     "rank": 2,
     "handle": "0-35-1-50-ct-round-cut-diamonds-solitaire-pendant-102676",
     "title": "0.35-1.50 CT Round Natural Diamond Solitaire Pendant",
     "fullTitle": "0.35-1.50 CT Round Cut Natural Diamonds - Solitaire Pendant",
     "url": "https://primestyle.com/products/0-35-1-50-ct-round-cut-diamonds-solitaire-pendant-102676",
     "origin": "Natural",
     "retail": 3290.0,
     "ps": 967.99,
     "psMin": 967.99,
     "retailMin": 3290.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.35CT Total",
      "0.45CT Total",
      "0.55CT Total",
      "1.00CT Total",
      "1.15CT Total",
      "1.25CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-102676-a-2ced4d59.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-102676-b-6f1b0a2b.jpg"),
     "imgSource": "cdn",
     "units": 7,
     "bestSeller": true
    },
    {
     "core": "15415",
     "sku": "15415-2",
     "rank": 0,
     "handle": "0-50-3-00-ct-round-cut-diamonds-stud-earrings-15415",
     "title": "0.50-3.00 CT Round Natural Diamond Stud Earrings",
     "fullTitle": "0.50-3.00 CT Round Cut Natural Diamonds - Stud Earrings",
     "url": "https://primestyle.com/products/0-50-3-00-ct-round-cut-diamonds-stud-earrings-15415",
     "origin": "Natural",
     "retail": 6850.0,
     "ps": 2107.99,
     "psMin": 1017.99,
     "retailMin": 3450.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.00CT Total",
      "1.50CT Total",
      "2.00CT Total",
      "2.50CT Total",
      "3.00CT Total",
      "0.50CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-15415-a-5d8888cf.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-15415-b-2d1c9e49.jpg"),
     "imgSource": "render",
     "units": 4,
     "bestSeller": true
    },
    {
     "core": "30015",
     "sku": "30015-2",
     "rank": 1,
     "handle": "hoop-and-drop-and-earrings-30015",
     "title": "1.30 CT Round Natural Diamond Hoop Earrings",
     "fullTitle": "1.30 CT Round Cut Natural Diamonds - Hoop And Drop And Earrings",
     "url": "https://primestyle.com/products/hoop-and-drop-and-earrings-30015",
     "origin": "Natural",
     "retail": 4500.0,
     "ps": 1450.99,
     "psMin": 1450.99,
     "retailMin": 4500.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.30CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-30015-a-15c0d2c9.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-30015-b-b6e9c7aa.jpg"),
     "imgSource": "cdn",
     "units": 3,
     "bestSeller": true
    },
    {
     "core": "15530",
     "sku": "15530-2",
     "rank": 5,
     "handle": "0-60-4-00-ct-round-cut-diamonds-tennis-bracelet-15530",
     "title": "0.60-4.00 CT Round Natural Diamond Tennis Bracelet",
     "fullTitle": "0.60-4.00 CT Round Cut Natural Diamonds - Tennis Bracelet",
     "url": "https://primestyle.com/products/0-60-4-00-ct-round-cut-diamonds-tennis-bracelet-15530",
     "origin": "Natural",
     "retail": 7280.0,
     "ps": 2346.99,
     "psMin": 2346.99,
     "retailMin": 7280.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.60CT Total",
      "1.00CT Total",
      "2.00CT Total",
      "3.00CT Total",
      "4.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-15530-a-3df58228.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-15530-b-47454c74.jpg"),
     "imgSource": "render",
     "units": 6,
     "bestSeller": false
    }
   ]
  },
  {
   "key": "studs",
   "label": "Diamond Stud Earrings",
   "handle": "diamond-stud-earrings",
   "products": [
    {
     "core": "15415",
     "sku": "15415-2",
     "rank": 0,
     "handle": "0-50-3-00-ct-round-cut-diamonds-stud-earrings-15415",
     "title": "0.50-3.00 CT Round Natural Diamond Stud Earrings",
     "fullTitle": "0.50-3.00 CT Round Cut Natural Diamonds - Stud Earrings",
     "url": "https://primestyle.com/products/0-50-3-00-ct-round-cut-diamonds-stud-earrings-15415",
     "origin": "Natural",
     "retail": 6850.0,
     "ps": 2107.99,
     "psMin": 1017.99,
     "retailMin": 3450.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.00CT Total",
      "1.50CT Total",
      "2.00CT Total",
      "2.50CT Total",
      "3.00CT Total",
      "0.50CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-15415-a-5d8888cf.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-15415-b-2d1c9e49.jpg"),
     "imgSource": "render",
     "units": 4,
     "bestSeller": true
    },
    {
     "core": "71193",
     "sku": "71193-2",
     "rank": 1,
     "handle": "0-25-2-00-ct-round-cut-diamonds-stud-earrings-71193",
     "title": "0.25-2.00 CT Round Natural Diamond Stud Earrings",
     "fullTitle": "0.25-2.00 CT Round Cut Natural Diamonds - Stud Earrings",
     "url": "https://primestyle.com/products/0-25-2-00-ct-round-cut-diamonds-stud-earrings-71193",
     "origin": "Natural",
     "retail": 2850.0,
     "ps": 854.99,
     "psMin": 854.99,
     "retailMin": 2850.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.25CT Total",
      "0.50CT Total",
      "0.80CT Total",
      "1.00CT Total",
      "1.50CT Total",
      "2.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71193-a-1d839b39.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71193-b-50d9d782.jpg"),
     "imgSource": "render",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "71901",
     "sku": "71901-2",
     "rank": 2,
     "handle": "0-25-2-00-ct-princess-cut-diamonds-stud-earrings-71901",
     "title": "0.25-2.00 CT Princess Natural Diamond Stud Earrings",
     "fullTitle": "0.25-2.00 CT Princess Cut Natural Diamonds - Stud Earrings",
     "url": "https://primestyle.com/products/0-25-2-00-ct-princess-cut-diamonds-stud-earrings-71901",
     "origin": "Natural",
     "retail": 3500.0,
     "ps": 1054.99,
     "psMin": 1054.99,
     "retailMin": 3500.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.25CT Total",
      "0.50CT Total",
      "0.80CT Total",
      "1.00CT Total",
      "1.50CT Total",
      "2.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71901-a-26107e3a.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71901-b-0dc01bde.jpg"),
     "imgSource": "render",
     "units": 1,
     "bestSeller": false
    },
    {
     "core": "15418",
     "sku": "15418-2",
     "rank": 5,
     "handle": "0-50-3-00-ct-round-cut-diamonds-stud-earrings-15418",
     "title": "0.50-3.00 CT Round Natural Diamond Stud Earrings",
     "fullTitle": "0.50-3.00 CT Round Cut Natural Diamonds - Stud Earrings",
     "url": "https://primestyle.com/products/0-50-3-00-ct-round-cut-diamonds-stud-earrings-15418",
     "origin": "Natural",
     "retail": 6750.0,
     "ps": 2107.99,
     "psMin": 1017.99,
     "retailMin": 3350.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.00CT Total",
      "1.50CT Total",
      "2.00CT Total",
      "2.50CT Total",
      "3.00CT Total",
      "0.50CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-15418-a-cead7dc2.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-15418-b-1f4dd58a.jpg"),
     "imgSource": "render",
     "units": 1,
     "bestSeller": false
    },
    {
     "core": "71194",
     "sku": "71194-2",
     "rank": 3,
     "handle": "0-25-2-00-ct-princess-cut-diamonds-stud-earrings-71194",
     "title": "0.25-2.00 CT Princess Natural Diamond Stud Earrings",
     "fullTitle": "0.25-2.00 CT Princess Cut Natural Diamonds - Stud Earrings",
     "url": "https://primestyle.com/products/0-25-2-00-ct-princess-cut-diamonds-stud-earrings-71194",
     "origin": "Natural",
     "retail": 3075.0,
     "ps": 954.99,
     "psMin": 954.99,
     "retailMin": 3075.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.25CT Total",
      "0.50CT Total",
      "0.80CT Total",
      "1.00CT Total",
      "1.50CT Total",
      "2.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71194-a-77eb02cc.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71194-b-4b2fa4c2.jpg"),
     "imgSource": "render",
     "units": 0,
     "bestSeller": false
    },
    {
     "core": "71933",
     "sku": "71933-2",
     "rank": 4,
     "handle": "0-25-2-00-ct-ascher-cut-diamonds-stud-earrings-71933",
     "title": "0.25-2.00 CT Ascher Natural Diamond Stud Earrings",
     "fullTitle": "0.25-2.00 CT Ascher Cut Natural Diamonds - Stud Earrings",
     "url": "https://primestyle.com/products/0-25-2-00-ct-ascher-cut-diamonds-stud-earrings-71933",
     "origin": "Natural",
     "retail": 3700.0,
     "ps": 1094.99,
     "psMin": 1041.99,
     "retailMin": 3400.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.25CT Total",
      "0.50CT Total",
      "0.80CT Total",
      "1.00CT Total",
      "1.50CT Total",
      "2.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71933-a-25dbe8f5.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71933-b-ca6f1894.jpg"),
     "imgSource": "render",
     "units": 0,
     "bestSeller": false
    }
   ]
  },
  {
   "key": "hoops",
   "label": "Diamond Hoop Earrings",
   "handle": "hoop-drop-earrings",
   "products": [
    {
     "core": "30015",
     "sku": "30015-2",
     "rank": 1,
     "handle": "hoop-and-drop-and-earrings-30015",
     "title": "1.30 CT Round Natural Diamond Hoop Earrings",
     "fullTitle": "1.30 CT Round Cut Natural Diamonds - Hoop And Drop And Earrings",
     "url": "https://primestyle.com/products/hoop-and-drop-and-earrings-30015",
     "origin": "Natural",
     "retail": 4500.0,
     "ps": 1450.99,
     "psMin": 1450.99,
     "retailMin": 4500.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.30CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-30015-a-15c0d2c9.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-30015-b-b6e9c7aa.jpg"),
     "imgSource": "cdn",
     "units": 3,
     "bestSeller": true
    },
    {
     "core": "30002",
     "sku": "30002-2",
     "rank": 0,
     "handle": "hoop-and-drop-earrings-30002",
     "title": "0.75-1.50 CT Round Natural Diamond Hoop Earrings",
     "fullTitle": "0.75-1.50 CT Round Cut Natural Diamonds - Hoop And Drop Earrings",
     "url": "https://primestyle.com/products/hoop-and-drop-earrings-30002",
     "origin": "Natural",
     "retail": 4140.0,
     "ps": 1336.99,
     "psMin": 1336.99,
     "retailMin": 4140.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.75CT Total",
      "1.00CT Total",
      "1.25CT Total",
      "1.50CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-30002-a-2fe69138.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-30002-b-e0c8e0a0.jpg"),
     "imgSource": "render",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "30003",
     "sku": "30003-2",
     "rank": 2,
     "handle": "hoop-and-drop-earrings-30003",
     "title": "4.00-7.00 CT Round Natural Diamond Hoop Earrings",
     "fullTitle": "4.00-7.00 CT Round Cut Natural Diamonds - Hoop And Drop Earrings",
     "url": "https://primestyle.com/products/hoop-and-drop-earrings-30003",
     "origin": "Natural",
     "retail": 12120.0,
     "ps": 3910.99,
     "psMin": 3910.99,
     "retailMin": 12120.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "4.00CT Total",
      "7.00CT Total",
      "6.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-30003-a-ee541f1f.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-30003-b-7d0b1544.jpg"),
     "imgSource": "render",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "30018",
     "sku": "30018-2",
     "rank": 5,
     "handle": "hoop-and-drop-and-earrings-30018",
     "title": "1.60 CT Round Natural Diamond Hoop Earrings",
     "fullTitle": "1.60 CT Round Cut Natural Diamonds - Hoop And Drop And Earrings",
     "url": "https://primestyle.com/products/hoop-and-drop-and-earrings-30018",
     "origin": "Natural",
     "retail": 7060.0,
     "ps": 2275.99,
     "psMin": 2275.99,
     "retailMin": 7060.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.60CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-30018-a-a34fc131.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-30018-b-628e7ae1.jpg"),
     "imgSource": "cdn",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "30019",
     "sku": "30019-2",
     "rank": 4,
     "handle": "hoop-and-drop-and-earrings-30019",
     "title": "1.20 CT Round Natural Diamond Hoop Earrings",
     "fullTitle": "1.20 CT Round Cut Natural Diamonds - Hoop And Drop And Earrings",
     "url": "https://primestyle.com/products/hoop-and-drop-and-earrings-30019",
     "origin": "Natural",
     "retail": 5310.0,
     "ps": 1711.99,
     "psMin": 1711.99,
     "retailMin": 5310.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.20CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-30019-a-1c791a9b.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-30019-b-fc2c053a.jpg"),
     "imgSource": "cdn",
     "units": 1,
     "bestSeller": false
    },
    {
     "core": "30005",
     "sku": "30005-2",
     "rank": 3,
     "handle": "hoop-and-drop-earrings-30005",
     "title": "5.50-8.50 CT Princess Natural Diamond Hoop Earrings",
     "fullTitle": "5.50-8.50 CT Princess Cut Natural Diamonds - Hoop And Drop Earrings",
     "url": "https://primestyle.com/products/hoop-and-drop-earrings-30005",
     "origin": "Natural",
     "retail": 13620.0,
     "ps": 4393.99,
     "psMin": 4393.99,
     "retailMin": 13620.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "5.50CT Total",
      "8.50CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-30005-a-5dd88166.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-30005-b-f7358905.jpg"),
     "imgSource": "render",
     "units": 0,
     "bestSeller": false
    }
   ]
  },
  {
   "key": "tennis",
   "label": "Tennis Bracelets",
   "handle": "diamond-tennis-bracelets",
   "products": [
    {
     "core": "71106",
     "sku": "71106-2",
     "rank": 0,
     "handle": "1-00-5-00-ct-round-cut-diamonds-tennis-bracelet-71106",
     "title": "1.00-5.00 CT Round Natural Diamond Tennis Bracelet",
     "fullTitle": "1.00-5.00 CT Round Cut Natural Diamonds - Tennis Bracelet",
     "url": "https://primestyle.com/products/1-00-5-00-ct-round-cut-diamonds-tennis-bracelet-71106",
     "origin": "Natural",
     "retail": 6480.0,
     "ps": 2089.99,
     "psMin": 2089.99,
     "retailMin": 6480.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.00CT Total",
      "2.00CT Total",
      "4.00CT Total",
      "5.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71106-a-73c9b592.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71106-b-a10f6a11.jpg"),
     "imgSource": "render",
     "units": 17,
     "bestSeller": true
    },
    {
     "core": "15530",
     "sku": "15530-2",
     "rank": 5,
     "handle": "0-60-4-00-ct-round-cut-diamonds-tennis-bracelet-15530",
     "title": "0.60-4.00 CT Round Natural Diamond Tennis Bracelet",
     "fullTitle": "0.60-4.00 CT Round Cut Natural Diamonds - Tennis Bracelet",
     "url": "https://primestyle.com/products/0-60-4-00-ct-round-cut-diamonds-tennis-bracelet-15530",
     "origin": "Natural",
     "retail": 7280.0,
     "ps": 2346.99,
     "psMin": 2346.99,
     "retailMin": 7280.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.60CT Total",
      "1.00CT Total",
      "2.00CT Total",
      "3.00CT Total",
      "4.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-15530-a-3df58228.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-15530-b-47454c74.jpg"),
     "imgSource": "render",
     "units": 6,
     "bestSeller": false
    },
    {
     "core": "104168",
     "sku": "104168-2",
     "rank": 1,
     "handle": "4-00-13-50-ct-princess-cut-diamonds-tennis-bracelet-104168",
     "title": "4.00-13.50 CT Princess Natural Diamond Tennis Bracelet",
     "fullTitle": "4.00-13.50 CT Princess Cut Natural Diamonds - Tennis Bracelet",
     "url": "https://primestyle.com/products/4-00-13-50-ct-princess-cut-diamonds-tennis-bracelet-104168",
     "origin": "Natural",
     "retail": 13000.0,
     "ps": 4192.99,
     "psMin": 4192.99,
     "retailMin": 13000.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "4.00CT Total",
      "5.00CT Total",
      "7.00CT Total",
      "9.00CT Total",
      "13.50CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-104168-a-5e3f42c3.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-104168-b-7bfbdbd8.jpg"),
     "imgSource": "render",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "104393",
     "sku": "104393-2",
     "rank": 2,
     "handle": "3-00-7-00-ct-round-cut-diamonds-tennis-bracelet-104393",
     "title": "3.00-7.00 CT Round Natural Diamond Tennis Bracelet",
     "fullTitle": "3.00-7.00 CT Round Cut Natural Diamonds - Tennis Bracelet",
     "url": "https://primestyle.com/products/3-00-7-00-ct-round-cut-diamonds-tennis-bracelet-104393",
     "origin": "Natural",
     "retail": 10220.0,
     "ps": 3295.99,
     "psMin": 3295.99,
     "retailMin": 10220.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "3.00CT Total",
      "4.00CT Total",
      "5.00CT Total",
      "6.00CT Total",
      "7.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-104393-a-b164d44a.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-104393-b-4307d2e2.jpg"),
     "imgSource": "render",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "71104",
     "sku": "71104-2",
     "rank": 3,
     "handle": "1-50-8-00-ct-round-cut-diamonds-tennis-bracelet-71104",
     "title": "1.50-8.00 CT Round Natural Diamond Tennis Bracelet",
     "fullTitle": "1.50-8.00 CT Round Cut Natural Diamonds - Tennis Bracelet",
     "url": "https://primestyle.com/products/1-50-8-00-ct-round-cut-diamonds-tennis-bracelet-71104",
     "origin": "Natural",
     "retail": 6470.0,
     "ps": 2085.99,
     "psMin": 2085.99,
     "retailMin": 6470.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "1.50CT Total",
      "2.50CT Total",
      "4.00CT Total",
      "6.00CT Total",
      "8.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71104-a-b164d44a.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71104-b-4307d2e2.jpg"),
     "imgSource": "render",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "71109",
     "sku": "71109-2",
     "rank": 4,
     "handle": "2-00-6-00-ct-round-cut-diamonds-tennis-bracelet-71109",
     "title": "2.00-6.00 CT Round Natural Diamond Tennis Bracelet",
     "fullTitle": "2.00-6.00 CT Round Cut Natural Diamonds - Tennis Bracelet",
     "url": "https://primestyle.com/products/2-00-6-00-ct-round-cut-diamonds-tennis-bracelet-71109",
     "origin": "Natural",
     "retail": 9030.0,
     "ps": 2912.99,
     "psMin": 2912.99,
     "retailMin": 9030.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "2.00CT Total",
      "4.00CT Total",
      "6.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71109-a-c367a809.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71109-b-037ec816.jpg"),
     "imgSource": "render",
     "units": 0,
     "bestSeller": false
    }
   ]
  },
  {
   "key": "eternity",
   "label": "Eternity Rings",
   "handle": "eternity-rings",
   "products": [
    {
     "core": "71731",
     "sku": "71731-2",
     "rank": 1,
     "handle": "2-50-6-00-ct-round-cut-diamonds-eternity-ring-71731",
     "title": "2.50-6.00 CT Round Natural Diamond Eternity Ring",
     "fullTitle": "2.50-6.00 CT Round Cut Natural Diamonds - Eternity Rings",
     "url": "https://primestyle.com/products/2-50-6-00-ct-round-cut-diamonds-eternity-ring-71731",
     "origin": "Natural",
     "retail": 7990.0,
     "ps": 2512.99,
     "psMin": 2512.99,
     "retailMin": 7990.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "2.50CT Total",
      "4.00CT Total",
      "6.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71731-a-0c4d19ec.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71731-b-32ca08c5.jpg"),
     "imgSource": "render",
     "units": 12,
     "bestSeller": true
    },
    {
     "core": "71716",
     "sku": "71716-2",
     "rank": 0,
     "handle": "4-00-7-00-ct-emerald-cut-diamonds-eternity-ring-71716",
     "title": "4.00-7.00 CT Emerald Natural Diamond Eternity Ring",
     "fullTitle": "4.00-7.00 CT Emerald Cut Natural Diamonds - Eternity Rings",
     "url": "https://primestyle.com/products/4-00-7-00-ct-emerald-cut-diamonds-eternity-ring-71716",
     "origin": "Natural",
     "retail": 12510.0,
     "ps": 4035.99,
     "psMin": 4035.99,
     "retailMin": 12510.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "4.00CT Total",
      "5.20CT Total",
      "7.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71716-a-ae2222f5.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71716-b-104f51c4.jpg"),
     "imgSource": "render",
     "units": 4,
     "bestSeller": false
    },
    {
     "core": "71704",
     "sku": "71704-2",
     "rank": 2,
     "handle": "2-00-6-00-ct-round-cut-diamonds-eternity-ring-71704",
     "title": "2.00-6.00 CT Round Natural Diamond Eternity Ring",
     "fullTitle": "2.00-6.00 CT Round Cut Natural Diamonds - Eternity Rings",
     "url": "https://primestyle.com/products/2-00-6-00-ct-round-cut-diamonds-eternity-ring-71704",
     "origin": "Natural",
     "retail": 7150.0,
     "ps": 2304.99,
     "psMin": 2304.99,
     "retailMin": 7150.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "2.00CT Total",
      "4.00CT Total",
      "6.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71704-a-50b8e805.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71704-b-62c114a2.jpg"),
     "imgSource": "render",
     "units": 4,
     "bestSeller": false
    },
    {
     "core": "71706",
     "sku": "71706-2",
     "rank": 4,
     "handle": "3-00-7-20-ct-round-cut-diamonds-eternity-ring-71706",
     "title": "3.00-7.20 CT Round Natural Diamond Eternity Ring",
     "fullTitle": "3.00-7.20 CT Round Cut Natural Diamonds - Eternity Rings",
     "url": "https://primestyle.com/products/3-00-7-20-ct-round-cut-diamonds-eternity-ring-71706",
     "origin": "Natural",
     "retail": 8430.0,
     "ps": 2717.99,
     "psMin": 2717.99,
     "retailMin": 8430.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "3.00CT Total",
      "5.00CT Total",
      "7.20CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71706-a-ce910889.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71706-b-23b396c1.jpg"),
     "imgSource": "render",
     "units": 3,
     "bestSeller": false
    },
    {
     "core": "71722",
     "sku": "71722-2",
     "rank": 3,
     "handle": "2-00-6-00-ct-round-cut-diamonds-eternity-ring-71722",
     "title": "2.00-6.00 CT Round Natural Diamond Eternity Ring",
     "fullTitle": "2.00-6.00 CT Round Cut Natural Diamonds - Eternity Rings",
     "url": "https://primestyle.com/products/2-00-6-00-ct-round-cut-diamonds-eternity-ring-71722",
     "origin": "Natural",
     "retail": 6260.0,
     "ps": 2019.99,
     "psMin": 2019.99,
     "retailMin": 6260.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "2.00CT Total",
      "4.00CT Total",
      "6.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71722-a-5be60247.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71722-b-65ab8818.jpg"),
     "imgSource": "render",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "15936",
     "sku": "15936-2",
     "rank": 5,
     "handle": "4-70-ct-princess-cut-blue-sapphires-diamonds-eternity-ring-15936",
     "title": "4.70 CT Princess Natural Diamond Eternity Ring",
     "fullTitle": "4.70 CT Princess Cut Natural Diamonds - Eternity Rings",
     "url": "https://primestyle.com/products/4-70-ct-princess-cut-blue-sapphires-diamonds-eternity-ring-15936",
     "origin": "Natural",
     "retail": 13670.0,
     "ps": 4408.99,
     "psMin": 4408.99,
     "retailMin": 13670.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "4.70CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-15936-a-724408a1.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-15936-b-384b3138.jpg"),
     "imgSource": "render",
     "units": 2,
     "bestSeller": false
    }
   ]
  },
  {
   "key": "pendants",
   "label": "Solitaire Pendants",
   "handle": "solitaire-pendants",
   "products": [
    {
     "core": "102676",
     "sku": "102676-2",
     "rank": 2,
     "handle": "0-35-1-50-ct-round-cut-diamonds-solitaire-pendant-102676",
     "title": "0.35-1.50 CT Round Natural Diamond Solitaire Pendant",
     "fullTitle": "0.35-1.50 CT Round Cut Natural Diamonds - Solitaire Pendant",
     "url": "https://primestyle.com/products/0-35-1-50-ct-round-cut-diamonds-solitaire-pendant-102676",
     "origin": "Natural",
     "retail": 3290.0,
     "ps": 967.99,
     "psMin": 967.99,
     "retailMin": 3290.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.35CT Total",
      "0.45CT Total",
      "0.55CT Total",
      "1.00CT Total",
      "1.15CT Total",
      "1.25CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-102676-a-2ced4d59.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-102676-b-6f1b0a2b.jpg"),
     "imgSource": "cdn",
     "units": 7,
     "bestSeller": true
    },
    {
     "core": "71388",
     "sku": "71388-2",
     "rank": 3,
     "handle": "0-06-ct-round-cut-diamonds-solitaire-pendant-71388",
     "title": "0.06 CT Round Natural Diamond Solitaire Pendant",
     "fullTitle": "0.06 CT Round Cut Natural Diamonds - Solitaire Pendant",
     "url": "https://primestyle.com/products/0-06-ct-round-cut-diamonds-solitaire-pendant-71388",
     "origin": "Natural",
     "retail": 3380.0,
     "ps": 994.99,
     "psMin": 994.99,
     "retailMin": 3380.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.06CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71388-a-e9dc04a2.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71388-b-b0397eb0.jpg"),
     "imgSource": "cdn",
     "units": 2,
     "bestSeller": false
    },
    {
     "core": "71376",
     "sku": "71376-2",
     "rank": 1,
     "handle": "0-05-0-25-ct-round-cut-diamonds-solitaire-pendant-71376",
     "title": "0.05-0.25 CT Round Natural Diamond Solitaire Pendant",
     "fullTitle": "0.05-0.25 CT Round Cut Natural Diamonds - Solitaire Pendant",
     "url": "https://primestyle.com/products/0-05-0-25-ct-round-cut-diamonds-solitaire-pendant-71376",
     "origin": "Natural",
     "retail": 3370.0,
     "ps": 989.99,
     "psMin": 952.99,
     "retailMin": 3240.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.05CT Total",
      "0.15CT Total",
      "0.25CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71376-a-7358203b.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71376-b-afe686fd.jpg"),
     "imgSource": "cdn",
     "units": 1,
     "bestSeller": false
    },
    {
     "core": "102679",
     "sku": "102679-2",
     "rank": 4,
     "handle": "0-35-1-00-ct-pear-cut-diamonds-solitaire-pendant-102679",
     "title": "0.35-1.00 CT Pear Natural Diamond Solitaire Pendant",
     "fullTitle": "0.35-1.00 CT Pear Cut Natural Diamonds - Solitaire Pendant",
     "url": "https://primestyle.com/products/0-35-1-00-ct-pear-cut-diamonds-solitaire-pendant-102679",
     "origin": "Natural",
     "retail": 3400.0,
     "ps": 998.99,
     "psMin": 998.99,
     "retailMin": 3400.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.35CT Total",
      "0.45CT Total",
      "0.55CT Total",
      "0.65CT Total",
      "1.00CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-102679-a-986537b3.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-102679-b-f1adf15f.jpg"),
     "imgSource": "cdn",
     "units": 1,
     "bestSeller": false
    },
    {
     "core": "102690",
     "sku": "102690-2",
     "rank": 5,
     "handle": "0-45-1-50-ct-round-cut-diamonds-solitaire-pendant-102690",
     "title": "0.45-1.50 CT Round Natural Diamond Solitaire Pendant",
     "fullTitle": "0.45-1.50 CT Round Cut Natural Diamonds - Solitaire Pendant",
     "url": "https://primestyle.com/products/0-45-1-50-ct-round-cut-diamonds-solitaire-pendant-102690",
     "origin": "Natural",
     "retail": 3450.0,
     "ps": 1113.99,
     "psMin": 1113.99,
     "retailMin": 3450.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.45CT Total",
      "0.55CT Total",
      "0.65CT Total",
      "0.75CT Total",
      "1.00CT Total",
      "1.25CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-102690-a-da67817f.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-102690-b-a2e909a3.jpg"),
     "imgSource": "cdn",
     "units": 1,
     "bestSeller": false
    },
    {
     "core": "71496",
     "sku": "71496-2",
     "rank": 0,
     "handle": "0-25-ct-round-cut-diamonds-solitaire-pendant-71496",
     "title": "0.25 CT Round Natural Diamond Solitaire Pendant",
     "fullTitle": "0.25 CT Round Cut Natural Diamonds - Solitaire Pendant",
     "url": "https://primestyle.com/products/0-25-ct-round-cut-diamonds-solitaire-pendant-71496",
     "origin": "Natural",
     "retail": 2870.0,
     "ps": 844.99,
     "psMin": 844.99,
     "retailMin": 2870.0,
     "metals": [
      "R",
      "W",
      "Y"
     ],
     "carats": [
      "0.25CT Total"
     ],
     "imgA": (window.PS_ASSET+"ps-gift26-products-71496-a-3bb19c6c.jpg"),
     "imgB": (window.PS_ASSET+"ps-gift26-products-71496-b-e01844de.jpg"),
     "imgSource": "cdn",
     "units": 0,
     "bestSeller": false
    }
   ]
  }
 ]
};
